import React from "react";
import Spinner from "components/spinner";

export const LoadingSpinner: React.FC = () => <div style={{ margin: "0 auto", width: "fit-content" }}>Loading... <Spinner size={24} /></div>;
